import axiosInstance from "../utilities/axiosSetup";

export const get_call_logs = async (filters) => {
  const response = await axiosInstance.get("/list-calls-interpreter", {
    params: filters,
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${sessionStorage.getItem("authToken")}`,
    },
  });
  return response.data;
};

export const list_all_languages = async () => {
  try {
    const { data } = await axiosInstance.get(
      import.meta.env.VITE_API_URL + "/list-all-languages",
      {
        headers: {
          Authorization: "Bearer " + sessionStorage.getItem("authToken"),
        },
      }
    );
    return data;
  } catch (error) {
    throw error;
  }
};

// export const get_data_to_download = async (filters) => {
//   const response = await axiosInstance.get(
//     "/get-data-to-download-interpreter",
//     {
//       params: filters,
//       withCredentials: true,
//       headers: {
//         Authorization: "Bearer " + sessionStorage.getItem("authToken"),
//       },
//     }
//   );
//   return response.data;
// };

export const get_data_to_download = async (filters = {}, onProgress = null) => {
  const response = await fetch(
    `${
      import.meta.env.VITE_API_URL
    }/get-data-to-download-interpreter?${new URLSearchParams(filters)}`,
    {
      headers: {
        Authorization: "Bearer " + sessionStorage.getItem("authToken"),
      },
    }
  );

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  let buffer = "";
  let allData = [];

  while (true) {
    const { done, value } = await reader.read();

    if (done) break;

    buffer += decoder.decode(value, { stream: true });

    // Try to parse complete JSON objects from buffer
    try {
      // Look for complete JSON structure
      if (buffer.includes('{"data":[') && buffer.includes("]}")) {
        const jsonStr = buffer.substring(
          buffer.indexOf('{"data":['),
          buffer.lastIndexOf("]}") + 2
        );
        const parsed = JSON.parse(jsonStr);
        allData = parsed.data;

        // Call progress callback if provided
        if (onProgress) {
          onProgress(allData.length);
        }
      }
    } catch (e) {
      // Continue accumulating buffer if JSON is incomplete
    }
  }

  return { data: allData };
};
